const { debounce } = window.BAO.Utils

class DetailsElement extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['summary', 'content']
  }

  connectedCallback () {
    super.connectedCallback()

    this.setMaxHeight()
  }

  setMaxHeight () {
    this.style.setProperty('--Max_Height', `${this.summaryHeight}px`)
  }

  setupListeners () {
    super.setupListeners()

    this.onSummaryClick = this.onSummaryClick.bind(this)
    this.setMaxHeight = this.setMaxHeight.bind(this)

    this.listeners.add(this.els.summary.element, 'click', this.onSummaryClick)

    const debouncedHandleResize = debounce(this.setMaxHeight, 250)
    this.listeners.add(window, 'resize', debouncedHandleResize.bind(this))
  }

  onSummaryClick () {
    this.isOpen = !this.isOpen
  }

  get summaryHeight () {
    const summary = this.els.content.element
    summary.style.maxHeight = 'none'

    const height = summary.offsetHeight
    summary.style.removeProperty('max-height')

    return height
  }

  get isOpen () {
    return this.hasAttribute('open')
  }

  set isOpen (val) {
    val ? this.setAttribute('open', '') : this.removeAttribute('open')

    this.els.content.element.setAttribute('aria-expanded', String(val))
  }
}

if (!customElements.get('details-element')) {
  customElements.define('details-element', DetailsElement)
}
